import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import CONFIG from "@/assets/js/config.custom.js";
import ValidationService from "@/services/ValidationService";
import {
  required,
  maxLength,
  integer,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
  name: "ItemCreate",
  components: {
    MainLayout,
    Select2Multiple,
  },
  mixins: [ValidationService],
  data() {
    return {
      itemData: {
        p_item_name: null,
        p_item_amount: null,
        item_type: '',
        campus_grade_ids: [],
        acd_year_id: '',
        transaction_category_id: '',
      },
      submitted: false,
      disabled: false,
      itemExists: false,
      itemTypeArr: [],
      gradeArr: [],
      acdYearArr: [],
      transactionCategoryArr: [],
      CONFIG,
      defaultSelectOption:  [{
                              'id': 0,
                              'text': 'All'
                            }],
    };
  },

  validations: {
    itemData: {
      p_item_name: {
        required,
        maxLength: maxLength(100)
      },
      p_item_amount: {
        required,
        integer,
        maxValue: maxValue(999999999),
        minValue: minValue(1)
      },
      item_type: {
        required,
        integer,
        minValue: minValue(1),
      },
      acd_year_id: {
        required,
        integer,
        minValue: minValue(1),
      },
    },
  },

  watch: {
    "itemData.item_type"() {
      this.validationErrors.item_type = [];
    },
    "itemData.campus_grade_ids"() {
      this.validationErrors.campus_grade_ids = [];
    },
    "itemData.acd_year_id"() {
      this.validationErrors.acd_year_id = [];
      this.validationErrors.campus_grade_ids = [];
      this.itemData.campus_grade_ids = [];
      this.gradeArr = [];
      this.getClasses();
    }
  },

  computed: {
    isValidGrades() {
      return this.itemData.campus_grade_ids.every(id => !isNaN(Number(id)));
    },

    isGradesExceedLimit() {
      return this.itemData.campus_grade_ids.join(",").length > 2000;
    }
  },

  methods: {
    getClasses() {
      if (!this.itemData.acd_year_id) {
        this.gradeArr = [];
        return;
      }
      axios.get('campusGrade/list-by-acdYear/', {
        params: {
          campus_id: this.$store.state.user.campus_id,
          acd_year_id: this.itemData.acd_year_id,
          get_grade: true,
        }
      }).then(res => {
        this.gradeArr = this.defaultSelectOption;
        this.gradeArr.push(...res.data.map(grade => {
          return {
            id: grade.campus_grade_id,
            text: grade.grade_name
          }
        }));
      })
        .catch((err) => {
          if (err.response && err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getAcademicYear() {
      axios.get("period/periodList")
        .then(res => {
          this.acdYearArr = res.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getTransactionCategories() {
      axios.get(`/transactionCategory/getTransactionCategoryArray?type=${CONFIG.TRANSACTION_TYPE.INCOME}`)
        .then(res => {
          const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
          this.transactionCategoryArr = [
            { id: 0, text: 'Select Transaction Category' },
            ...categoryList.map((category) => ({
              id: category.id,
              text: category.text ?? category.category_name ?? "",
            }))
          ];
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    preventKeys(e) {
      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
        e.preventDefault();
      }
    },

    async checkDuplicateItem() {
      try {
        const response = await axios.get("/item/checkDuplicateItem", {
          params: {
            item_name: this.itemData.p_item_name,
            acd_year_id: this.itemData.acd_year_id || null,
          },
        });
        this.itemExists = response.data.exists;
        this.submitted = false;
        this.disabled = false;
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },

    confirmRegister() {
      if (this.disabled) return;
      this.submitted = true;
      this.disabled = true;
      this.create();
    },

    async create() {
      if (this.$v.$invalid || !this.isValidGrades || this.isGradesExceedLimit) {
        this.disabled = false;
        return;
      }
      this.submitted = false;
      await this.checkDuplicateItem();
      if (this.itemExists) {
        this.$notification.error("Payment Item Name is already exist.", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }
      this.isLoading = true;
      this.itemData.campus_grade_ids = this.itemData.campus_grade_ids.map(id => Number(id));
      this.itemData.loginID = this.$store.state.user.id;
      const payload = {
        ...this.itemData,
        transaction_category_id: this.itemData.transaction_category_id && this.itemData.transaction_category_id !== 0
          ? this.itemData.transaction_category_id
          : 0,
      };
      axios.post('item/create', payload)
        .then(res => {
          if (res.data.success === true) {
            this.$notification.success("Item Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'itemList'
            })
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            })
          }
        }).catch(error => {
          if (error.response?.status === 422) {
            this.printValidationError(error.response);
          } else {
            this.printValidationError(error.response);
          }
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        }).finally(() => {
          this.disabled = this.isLoading = false;
        });
    }
  },

  mounted() {
    this.itemTypeArr = Object.entries(this.CONFIG.PAYMENT_ITEM_TYPES)
      .map(([id, text]) => ({ id, text }));
    this.itemData.item_type = 2;
    this.getClasses();
    this.getAcademicYear();
    this.getTransactionCategories();
  },
};
